/**
 * AI 문서 아카이브 — 지출·세금 증빙 OCR (카드영수증·세금계산서)
 * 촬영/업로드 두 경로 모두 동일한 리사이즈 파이프라인을 거친다 — 한쪽만 거치면 절감 효과가 없다.
 * [[20260923-OCR-LLM비전API-토큰소비및관리전략]] §7 / [[20260923-AI문서아카이브...]] §4.1
 *
 * 실제 OCR API 연동 전이라 archiveDocStore.simulateExtraction()으로 빈 필드를 제안하고,
 * 사람이 직접 입력·확인해 저장한다(BE 연동 시 그 함수만 교체하면 됨).
 */
import React from 'react';
import { PageContainer } from 'styles/common.styles';
import DocCaptureArchivePanel from 'archive/DocCaptureArchivePanel';

const ArchiveOcr = () => (
  <PageContainer>
    <DocCaptureArchivePanel
      category="OCR"
      panelTitle="인식 결과 확인·입력"
      afterSaveHint="아카이브에 저장했습니다. (지출결의 연동은 BE 매핑 어댑터 구현 후)"
    />
  </PageContainer>
);

export default ArchiveOcr;
